import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router/router'
import MultiLanguage from 'vue-multilanguage'
import language from './lang/language'
import axios from './router/http'
import events from '@/common/js/events.js'
import InfiniteScroll from 'mint-ui/lib/infinite-scroll'
import Loadmore from 'mint-ui/lib/loadmore'
import 'mint-ui/lib/style.css'

Vue.config.productionTip = false
Vue.use(MultiLanguage, language)
Vue.use(InfiniteScroll)
Vue.use(events)
Vue.prototype.$ajax = axios
Vue.component(Loadmore.name, Loadmore)
Vue.directive('search', {
  bind: function (el, binding, vnode) {
    if (store.state.fileInfo.isSearch) {
      let keyword = store.state.searchKeyword
      let txt
      if (keyword === '.') {
        txt = binding.value.replace(new RegExp(/\./, 'g'), '<label style="color:red">' + keyword + '</label>')
      } else {
        txt = binding.value.replace(new RegExp(keyword, 'g'), '<label style="color:red">' + keyword + '</label>')
      }

      el.innerHTML = txt
    } else {
      el.innerHTML = binding.value
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js